import { useCallback } from "react";
import { graphql, useStaticQuery } from "gatsby";

const useReevooTrack = (productId) => {
  const {
    config: { isReevooActive, reevooAccountCode },
    labelManagerLabels,
  } = useStaticQuery(graphql`
    {
      config: liferayGeneralConfiguration {
        isReevooActive
        reevooAccountCode
      }
      labelManagerLabels: labelManagerLabels {
        foundRetailers
        buyNow
      }
    }
  `);
  const reevooTrack = useCallback(() => {
    if (typeof window !== "undefined" && isReevooActive !== "[]") {
      if (window.reevooMark) {
        window.reevooMark("trackPropensityToBuy", reevooAccountCode, {
          sku: productId,
          cta: labelManagerLabels.foundRetailers || labelManagerLabels.buyNow,
        });
      }
    }
  }, [productId, labelManagerLabels, isReevooActive, reevooAccountCode]);

  return reevooTrack;
};

export default useReevooTrack;
